import {useAuth} from "../../services/use-auth";
import {useTranslation} from "react-i18next";
import classNames from 'classnames';
import EventListPrice from "./EventListPrice";
import EventListLocation from "./EventListLocation";
import {Link} from "react-router-dom";

export default function EventListItem({item, isPinned}) {
    const {
        id,
        image,
        prices,
        isFinished,
        isGroup,
        groupItemsCount,
        specialties,
        name,
        location,
        dateEnd,
        dateStart,
        hasCertificate
    } = item;
    const { t } = useTranslation();
    const auth = useAuth();
    const isFree = !prices.length && !isFinished;
    const showRecommendedBlock = !!specialties.filter(x => auth.user?.allSpecialties.includes(x)).length;

    return (
        <Link to={`/conference/${id}`} className="conference-preview">
            <figure>
                <div className="img-wrap">
                    <img src={`/${image.replace(/^\/+/, '')}`} className="img-fill" alt="conferenceImage" />
                    {isPinned && <div className="conference-status top">{t('surveys.top')}</div>}
                    <div
                        className={classNames('conference-status', {"free": isFree, "finished": isFinished})}>
                        <EventListPrice
                            prices={prices}
                            isFinished={isFinished}
                        />
                    </div>
                </div>
                {isGroup &&
                    <div className="conferences-group-count">{ t('main.updates.conferenceGroupCaption') } {groupItemsCount}</div>
                }
                <figcaption className="description">
                    { showRecommendedBlock && <span>{ t('conferences.conference.recommended') }</span> }
                    <h6>
                        {name}
                    </h6>
                </figcaption>
            </figure>
            <div className="info-block">
                <ul className="flex-center">
                    <EventListLocation location={location} />
                    <li className="date">{dateEnd.includes(dateStart) ? `${dateEnd}` : `${dateStart} - ${dateEnd}`}</li>
                    <li className={classNames('certificate', {"has-certificate": hasCertificate})} />
                </ul>
            </div>
        </Link>
    );
}
